import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialTaxesModel } from './types';
import { financialTaxesItemValidator } from './validators/item';

const financialTaxesValidator: ValidateJSModel<FinancialTaxesModel> = {
  HasTaxes: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasTaxes?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: financialTaxesItemValidator },
      };
    }

    return {};
  },
};

export default financialTaxesValidator;
